module.exports = __webpack_public_path__ + "img/it.80b5f2ae.svg";